import styled from 'styled-components';
import { BaseIcon } from '../../../CommonComponents/OPL/Icon/Icon';

export const ProgressIcon = styled(BaseIcon)(({ theme }) => ({
  borderRadius: 8,
  cursor: 'pointer',

  '&[data-focus-visible-added]:focus': {
    boxShadow: `0px 0px 0px 2px ${theme.colors.primary['300']}`,
    zIndex: 1,
  },
}));
